/**
 * Zoom image control
 *
 * Handles toggling the zoom onclick.
 */
(function($) {

    // For each zoom wrapper, get the large image data attribute, and then set that as zoom image URL
    $('.zoom-image-wrapper').each(
        function(i, obj){
            let large_image = $(obj).find('.zoomable').data('zoom-img');
            $(obj).zoom( {on: "click", magnify: 1, url: large_image } );
        }
    )

}(jQuery));
